<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Пакеты в работе</b-card-title>
      <b-badge variant="light-primary">{{ inProgress }}</b-badge>
    </b-card-header>
    <b-card-body class="pt-0">
      <div v-if="!byStatus.length" class="text-center text-muted py-2">Открытых задач авторов нет</div>
      <div v-for="item in byStatus" :key="item.status" class="mb-75">
        <div class="d-flex justify-content-between font-small-3">
          <span>{{ item.status }}</span>
          <span class="font-weight-bold">{{ item.count }}</span>
        </div>
        <b-progress :value="item.count" :max="maxCount" height="6px" :variant="statusVariant(item.status)" />
      </div>
      <small class="text-muted">Задачи авторов в Planfix без статусов «оплачено» / «завершенная»</small>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BProgress,
} from 'bootstrap-vue'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BProgress,
  },
  props: {
    authorTasks: { type: Object, default: null },
  },
  setup(props) {
    const byStatus = computed(() => (props.authorTasks && props.authorTasks.by_status) || [])
    const inProgress = computed(() => (props.authorTasks && props.authorTasks.in_progress_count) || 0)
    const maxCount = computed(() => Math.max(1, ...byStatus.value.map(item => item.count)))
    const statusVariant = status => {
      const normalized = (status || '').toLowerCase()
      if (normalized.includes('выполн')) return 'success'
      if (normalized.includes('провер') || normalized.includes('ревью')) return 'warning'
      return 'primary'
    }
    return {
      byStatus, inProgress, maxCount, statusVariant,
    }
  },
}
</script>
